import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { formatCounterAmount } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'

interface Props {
  amount: number
  isHourlyFixedBalance: boolean
}

const Carryovers = ({ amount, isHourlyFixedBalance }: Props) => {
  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal>{i18n.t('time_off.new_available_tooltip.carryover')}</Text.Normal>
        <Text.Normal>{formatCounterAmount(amount, isHourlyFixedBalance)}</Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="flexStart">
        <Text.Normal size="200">{i18n.t('time_off.available_tooltip.current_cycle')}</Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(Carryovers)
